import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Container, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  chgEspaceFilter,
  chgPartieprenanteFilter,
  chgRituelFilter,
  chgRoleFilter,
  chgTempscollectifFilter,
  selectInGouvernanceFilters,
} from "../../../redux/ReduxFilter";

const BlocFiltreInGovernance = (props) => {
  const { t } = useTranslation();
  const { viewToggle } = props;
  const scrollContainerRef = useRef(null);
  const checkedCheckboxRef = useRef(null);

  // Redux
  const dispatch = useDispatch();
  const _selectInGouvernanceFilters = useSelector(selectInGouvernanceFilters);

  useEffect(() => {
    if (checkedCheckboxRef.current && scrollContainerRef.current) {
      // Obtenir la position de la checkbox cochée
      const checkboxRect = checkedCheckboxRef.current.getBoundingClientRect();

      // Obtenir la largeur de la fenêtre (ou du conteneur parent)
      const containerRect = scrollContainerRef.current.getBoundingClientRect();

      // Calculer la position de défilement pour centrer l'élément
      const scrollLeftPosition =
        checkboxRect.left - containerRect.left - containerRect.width / 2 + checkboxRect.width / 2;

      // Déplacer la scrollbar
      scrollContainerRef.current.scrollTo({
        left: scrollLeftPosition,
        behavior: "smooth", // pour un effet de défilement fluide
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="sliderSticky">
      <div className="enteteBlocFiltre">
        <span>{t("public.filtres.filtre22")}</span>
      </div>
      <Container
        fluid
        className="mb-3 d-flex align-items-center flex-nowrap containerFiltres"
        ref={scrollContainerRef}
      >
        <div className="m-1  align-items-center d-flex ">
          {viewToggle && <Form.Check type="checkbox" label="Processus" disabled />}
          {!viewToggle && (
            <Link to={"/cartographie-processus"} className="filtreNonActif">
              <Form.Check type="checkbox" label={t("public.filtres.filtre1")} />
            </Link>
          )}
        </div>
        <div className="m-1   align-items-center d-flex" id="filtreContainerEspace">
          <Form.Check
            className={_selectInGouvernanceFilters.espace ? "filtreActif" : "filtreNonActif"}
            type="checkbox"
            label={t("public.filtres.filtre2")}
            id="espace"
            name="espace"
            onChange={(e) => dispatch(chgEspaceFilter(!_selectInGouvernanceFilters.espace))}
            checked={_selectInGouvernanceFilters.espace ? "checked" : ""}
          />
        </div>
        <div
          className="m-1  align-items-center d-flex"
          id="filtreContainerRituel"
          ref={checkedCheckboxRef}
        >
          <Form.Check
            className={_selectInGouvernanceFilters.rituel ? "filtreActif" : "filtreNonActif"}
            type="checkbox"
            id="rituel"
            name="rituel"
            checked={_selectInGouvernanceFilters.rituel ? "checked" : ""}
          >
            <Form.Check.Input
              type="checkbox"
              onChange={(e) => dispatch(chgRituelFilter(!_selectInGouvernanceFilters.rituel))}
            />
            <Form.Check.Label>
              {t("public.filtres.filtre3")}
              {viewToggle && <span className="ms-2 chronoItemTypeRituel"></span>}
            </Form.Check.Label>
          </Form.Check>

          {/* <Form.Check
          className={_selectInGouvernanceFilters.rituel ? "filtreActif" : "filtreNonActif"}
          type="checkbox"
          label={t("public.filtres.filtre3")}
          id="rituel"
          name="rituel"
          onChange={(e) => dispatch(chgRituelFilter(!_selectInGouvernanceFilters.rituel))}
          checked={_selectInGouvernanceFilters.rituel ? "checked" : ""}
        /> 
        {viewToggle && <span className="ms-2 chronoItemTypeRituel"></span>}*/}
        </div>
        <div className="m-1  align-items-center d-flex" id="filtreContainerTempsCollectif">
          <Form.Check
            className={
              _selectInGouvernanceFilters.tempscollectif ? "filtreActif" : "filtreNonActif"
            }
            type="checkbox"
            id="tempscollectif"
            name="tempscollectif"
            checked={_selectInGouvernanceFilters.tempscollectif ? "checked" : ""}
          >
            <Form.Check.Input
              type="checkbox"
              onChange={(e) =>
                dispatch(chgTempscollectifFilter(!_selectInGouvernanceFilters.tempscollectif))
              }
            />
            <Form.Check.Label>
              {t("public.filtres.filtre4")}
              {viewToggle && <span className="ms-2 chronoItemTypeTemps"></span>}
            </Form.Check.Label>
          </Form.Check>
          {/* <Form.Check
          className={_selectInGouvernanceFilters.tempscollectif ? "filtreActif" : "filtreNonActif"}
          type="checkbox"
          label={t("public.filtres.filtre4")}
          id="tempscollectif"
          name="tempscollectif"
          onChange={(e) =>
            dispatch(chgTempscollectifFilter(!_selectInGouvernanceFilters.tempscollectif))
          }
          checked={_selectInGouvernanceFilters.tempscollectif ? "checked" : ""}
        />
        {viewToggle && <span className="ms-2 chronoItemTypeTemps"></span>} */}
        </div>
        <div className="m-1  align-items-center d-flex" id="filtreContainerRole">
          {viewToggle && (
            <Form.Check type="checkbox" label={t("public.filtres.filtre5")} disabled />
          )}
          {!viewToggle && (
            <Form.Check
              className={_selectInGouvernanceFilters.role ? "filtreActif" : "filtreNonActif"}
              type="checkbox"
              label={t("public.filtres.filtre5")}
              id="role"
              name="role"
              onChange={(e) => dispatch(chgRoleFilter(!_selectInGouvernanceFilters.role))}
              checked={_selectInGouvernanceFilters.role ? "checked" : ""}
            />
          )}
        </div>
        <div className="m-1  align-items-center d-flex" id="filtreContainerPartiePrenante">
          {viewToggle && (
            <Form.Check type="checkbox" label={t("public.filtres.filtre6")} disabled />
          )}
          {!viewToggle && (
            <Form.Check
              className={
                _selectInGouvernanceFilters.partieprenante ? "filtreActif" : "filtreNonActif"
              }
              type="checkbox"
              label={t("public.filtres.filtre6")}
              id="partieprenante"
              name="partieprenante"
              onChange={(e) =>
                dispatch(chgPartieprenanteFilter(!_selectInGouvernanceFilters.partieprenante))
              }
              checked={_selectInGouvernanceFilters.partieprenante ? "checked" : ""}
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default BlocFiltreInGovernance;
